import { Directive, ElementRef, Input, inject } from '@angular/core';

@Directive({
  selector: '[wtAutofocus]',
})
export class WtAutofocusDirective {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @Input() set wtAutofocus(condition: boolean | string) {
    if (condition !== false) {
      window.setTimeout(() => {
        this.el.nativeElement.focus();
      });
    }
  }
}
